import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

export default function ColumnViewPanel({
  columns,
  columnView,
  handleColumnChange,
}) {
  return (
    <Card sx={{ width: 280, height: "fit-content" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Column View
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {columns.map(({ key, label }) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={columnView[key]}
                  onChange={() => handleColumnChange(key)}
                  size="small"
                />
              }
              label={<Typography variant="body2">{label}</Typography>}
              sx={{ ml: 0 }}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
